import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Container, Box } from '@mui/material';

function PrivacyPolicy({ open, onClose, standalone = false }) {
  const content = (
    <>
      <Typography variant="body1" paragraph>
        Last updated: 9/26/2024
      </Typography>
      <Typography variant="h6" gutterBottom>
        1. Introduction
      </Typography>
      <Typography variant="body1" paragraph>
        PIE Career ("we", "our", or "us") respects your privacy and is committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data and tell you about your privacy rights and how the law protects you.
      </Typography>
      <Typography variant="h6" gutterBottom>
        2. The Data We Collect About You
      </Typography>
      <Typography variant="body1" paragraph>
        We may collect, use, store and transfer different kinds of personal data about you, including:
        • Identity Data: first name, last name, username or similar identifier
        • Contact Data: email address and telephone numbers
        • Technical Data: internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform
        • Usage Data: information about how you use our website and services
        • Analytics Data: information collected through Google Analytics about your website usage, including pages visited, time spent on pages, and other interaction data
      </Typography>
      <Typography variant="h6" gutterBottom>
        3. Cookies and Tracking Technologies
      </Typography>
      <Typography variant="body1" paragraph>
        We use cookies and similar tracking technologies to track activity on our website and hold certain information. Cookies are files with small amount of data which may include an anonymous unique identifier. 

        We use Google Analytics, a web analytics service provided by Google, Inc. Google Analytics uses cookies to help us analyze how users use our site. The information generated by the cookie about your use of the website (including your IP address) will be transmitted to and stored by Google on servers in the United States. Google will use this information for the purpose of evaluating your use of the website, compiling reports on website activity for website operators and providing other services relating to website activity and internet usage. 

        You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.
      </Typography>
      <Typography variant="h6" gutterBottom>
        4. Sharing of Your Personal Data
      </Typography>
      <Typography variant="body1" paragraph>
        We may share your personal data with:
        • Service providers who provide IT and system administration services, such as Google for analytics purposes.
        • Professional advisers including lawyers, bankers, auditors and insurers.
        • Regulators and other authorities who require reporting of processing activities in certain circumstances.
        We require all third parties to respect the security of your personal data and to treat it in accordance with the law.
      </Typography>
      <Typography variant="h6" gutterBottom>
        5. Your Legal Rights
      </Typography>
      <Typography variant="body1" paragraph>
        Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, to object to processing, to portability of data and (where the lawful ground of processing is consent) to withdraw consent.

        You can opt out of Google Analytics tracking by using the Google Analytics Opt-out Browser Add-on, available at https://tools.google.com/dlpage/gaoptout.
      </Typography>
      <Typography variant="h6" gutterBottom>
        6. Changes to This Privacy Policy
      </Typography>
      <Typography variant="body1" paragraph>
        We may update our privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the "Last updated" date at the top of this privacy policy.
      </Typography>
      <Typography variant="h6" gutterBottom>
        7. Contact Us
      </Typography>
      <Typography variant="body1" paragraph>
        If you have any questions about this privacy policy or our privacy practices, please contact us at:
        Email: privacy@pie-career.com
      </Typography>
    </>
  );

  if (standalone) {
    return (
      <Container maxWidth="md">
        <Box my={4}>
          <Typography variant="h4" component="h1" gutterBottom>
            Privacy Policy
          </Typography>
          {content}
        </Box>
      </Container>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} scroll="paper" maxWidth="md" fullWidth>
      <DialogTitle>Privacy Policy</DialogTitle>
      <DialogContent dividers>
        {content}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default PrivacyPolicy;